{
  "Added by you": "Tillagt av dig",
  "Total": "Total lärtid",
  "first-challenge": "Din första utmaning",
  "second-challenge": "Din andra utmaning",
  "third-challenge": "Din tredje utmaning",
  "fourth-challenge": "Din fjärde utmaning",
  "fifth-challenge": "Din femte utmaning",
  "Contact support": "Kontakta support",
  "Send feedback": "Skicka feedback",
  "track-time": "Registrera lärtid",
  "External time": "Extern lärtid",
  "Register time spent on external activites": "Registrera tid lagd på läraktiviteter.",
  "Time spent on external courses": "Tid spenderad på aktiviteter",
  "Profile": "Profil",
  "Add time": "Lägg till tid",
  "current-challenge": "Nuvarande utmaning",
  "my-learning-goal": "Mitt lärandemål",
  "my-learning-progress": "Min lärprogress",
  "past-six-months": "Senaste 6 månaderna",
  "my-invested-time": "Min lärtid",
  "view-completed": "Visa slutfört lärande",
  "current-year-challenge": "{{startDay}} {{startMonth}} {{startYear}} - {{endDay}} {{endMonth}} {{endYear}}",
  "home-text-top": "Den genomsnittliga lärtiden är {{companyHours}}t. Med dina  <0>{{userTime}}</0> ligger du bland topp {{percentageTop}}%. Imponerande. Kör på!",
  "home-text-mid": "Den genomsnittliga lärtiden är {{companyHours}}t. Med dina  <0>{{userTime}}</0> ligger du bland topp {{percentageTop}}%. Vad är ditt nästa steg?",
  "home-text-low": "Den genomsnittliga lärtiden är {{companyHours}}t. Din lärtid hittills är  <0>{{userTime}}</0>. Vad är ditt nästa steg?",
  "my-invested-time-description": "<0>Min lärtid</0> tar följande källor i beaktning:",
  "- Programs, learning paths, and resources": "- Program, lärvägar, och resurser",
  "my-invested-time-disclaimer": "På grund av tekniska beroenden till externa leverantörer kan värden i <7>Min lärtid</7> vara fördröjda upp till 72 timmar.",
  "Manually added other learning time": "Manuellt tillagd tid",
  "What data is not included?": "Vilken data inkluderas inte?",
  "continue-Learning": "Fortsätt lära",
  "assigned": "Tilldelade",
  "my-events": "Mina event",
  "saved": "Sparat",
  "featured": "Tips",
  "show-all": "Visa Alla",
  "explore-all": "Vissa All Lärobjekt",
  "choose-learnings-items-count": "Välj lärobjekt ({{count}} tillgängliga)",
  "featured-learning-items": "Utvalda lärobjekt",
  "no-featured-learning-items": "Inga lärobjekt utvalda",
  "featured-learnings": "Utvalda"
}
